import {combineReducers, configureStore} from '@reduxjs/toolkit';
import brandGuidelinesPageReducer from 'common/src/modules/brandGuidelines/store/brandGuidelinesPage.slice';
import campaignPageReducer from 'common/src/modules/campaigns/store/campaignPage.slice';
import campaignsLibraryReducer from 'common/src/modules/campaigns/store/campaignsLibrary/campaignsLibrary.slice';
import copilotReducer from 'common/src/modules/shared/copilot/store/copilot.slice';
import targetPlatformsReducer from 'common/src/modules/targetPlatform/store/targetPlatforms.slice';
import {FLUSH, PAUSE, PERSIST, persistStore, PURGE, REGISTER, REHYDRATE} from 'redux-persist';
import catalogFeedTabReducer from '../modules/catalogFeed/store/catalogFeed.slice';
import contentFeedPageReducer from '../modules/contentFeeds/store/contentFeedPage/contentFeedPage.slice';
import creativePageReducer from '../modules/creatives/store/creativePage/creativePage.slice';
import creativesLibraryReducer from '../modules/creatives/store/creativesLibrary/creativesLibrary.slice';
import creativeTemplatePageReducer from '../modules/creativeTemplates/store/creativeTemplatePage/creativeTemplatePage.slice';
import creativeTemplatesLibraryReducer from '../modules/creativeTemplates/store/creativeTemplatesLibrary/creativeTemplatesLibrary.slice';
import creativeWidgetPageReducer from '../modules/creativeTemplates/store/creativeWidgetPage/creativeWidgetPage.slice';
import dashboardReducer from '../modules/dashboards/store/dashboardPage.slice';
import creativeWidgetsTableReducer from '../modules/dynamicParameters/widgets/store/creativeWidgetsTable.slice';
import assetsLibraryPageReducer from '../modules/Assets/store/assetsLibraryPage.slice';
import applicationReducer from './application.slice';
import luxonDateTimeMiddleware from './middlewares/luxonDateTimeMiddleware/luxonDateTimeMiddleware';
import aiContentProjectReducer from '../modules/aiContent/store/aiContentProject/aiContentProject.slice';

const rootReducer = combineReducers({
  application: applicationReducer,
  copilot: copilotReducer,
  contentFeedPage: contentFeedPageReducer,
  campaignPage: campaignPageReducer,
  creativeWidgetsTable: creativeWidgetsTableReducer,
  campaignsLibrary: campaignsLibraryReducer,
  creativeTemplatesLibrary: creativeTemplatesLibraryReducer,
  creativeTemplatePage: creativeTemplatePageReducer,
  creativeWidgetPage: creativeWidgetPageReducer,
  creativesLibrary: creativesLibraryReducer,
  creativePage: creativePageReducer,
  targetPlatforms: targetPlatformsReducer,
  brandGuidelinesPage: brandGuidelinesPageReducer,
  assetsLibraryPage: assetsLibraryPageReducer,
  dashboard: dashboardReducer,
  catalogFeed: catalogFeedTabReducer,
  dashboardPage: dashboardReducer,
  aiContentProjectPage: aiContentProjectReducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // https://redux-toolkit.js.org/usage/usage-guide#use-with-redux-persist
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).prepend(luxonDateTimeMiddleware),
});

const persistor = persistStore(store);

// Define the RootState and AppDispatch types
export type RootState = ReturnType<typeof rootReducer>;
export type CLDispatch = typeof store.dispatch;

export type CLStore = {
  getState: () => RootState;
  dispatch: CLDispatch;
};

export {persistor, store};
